import { Fragment } from 'react';

import Views from '../OrgUnitAdminUserViews';
import ViewTemplate from '../../../../components/viewTemplateOmeTeamEntry/ViewTemplate';

import useOrgUnitAdminRosterEntries from './UseOrgUnitAdminRosterEntries';

import OrgUnitAdminRosterEntriesGrid from './OrgUnitAdminRosterEntriesGrid';

import YesNoSwitch from '@usas/ui-web/components/yesNoSwitch/YesNoSwitch';
import Combobox from '@usas/ui-web/components/comboboxes/Combobox';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal'
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';

import Constants from '@usas/ui-web/utils/Constants';

import style from '../../Entry.module.css';

const OrgUnitAdminRosterEntries = () => {
  const { oUAdminEntryContextState, onNextButtonClicked, onSaveAndExitButtonClicked, onBackButtonClicked, state,
    gridState, setGridState, omeMeetOrgUnitAthleteEntryIndividualRosterEntryState, omeMeetOrgUnitEntryInfoState, omeMeetOrgUnitEntryTimesState,
    handleSubmit, formState, errorState, onValueTextPairChanged, onEditAthleteClicked, onDeleteAthleteClicked, onDeleteAthlete,
    onAddSecondaryRepToAthleteClicked, omeMeetOrgUnitAthleteEntryState, approvedClubsForSecondaryRepState, athleteSecondaryRepresentationState,
    onAddAthlete, onUpdateAthleteTimes, onUpdateRosterTimes, modalState, onModalCanceled, secondaryRepModalState, onSecondaryRepModalCanceled,
    omeMeetOrgUnitEntryRosterPermissionsState } = useOrgUnitAdminRosterEntries();

  return (
    <Fragment>
      <ViewTemplate
        viewName={Views.OME_MEET_ROSTER_ENTRIES}
        onNextButtonClicked={onNextButtonClicked}
        onSaveAndExitButtonClicked={onSaveAndExitButtonClicked}
        onBackButtonClicked={onBackButtonClicked}
        errorMessage={state.error}>
        {oUAdminEntryContextState.isReadOnly === false ?
          <Fragment>
            <div className='row'>
              <div className="col-xs-12 usas-extra-top-margin">
                <ActionIntraPageButton type="button" onClick={onAddAthlete}>Select Athletes</ActionIntraPageButton>
              </div>
            </div>
            <form>
              <div className="row">
                <div className="col-xs-12 usas-extra-top-margin">
                  <YesNoSwitch
                    label="Only Show Athletes Requiring Event Approval?"
                    name="onlyShowAthletesRequiringEventApproval"
                    checked={gridState.onlyShowAthletesRequiringEventApproval}
                    onChange={(value) => { setGridState({ ...gridState, onlyShowAthletesRequiringEventApproval: value }) }} />
                </div>
              </div>
            </form>
            {gridState.gridData.length > 5 && gridState.showUpdateButton === true && omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.isArrayLoading === false &&
              omeMeetOrgUnitAthleteEntryState.isArrayLoading === false &&
              <div className='visible-md visible-lg'>
                <div className="row">
                  <div className={style.FloatRight}>
                    <div className="col-xs-12 usas-extra-top-margin">
                      <PrimaryButton onClick={(e) => onUpdateRosterTimes(e)}>Update Individual Event Entry Times for Entire Roster</PrimaryButton>
                    </div>
                  </div>
                </div>
              </div>}
            {gridState.gridData.length > 0 && gridState.showUpdateButton === true && omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.isArrayLoading === false &&
              omeMeetOrgUnitAthleteEntryState.isArrayLoading === false &&
              <div className='hidden-md hidden-lg'>
                <div className="row">
                  <div className={style.FloatRight}>
                    <div className="col-xs-12 usas-extra-top-margin">
                      <PrimaryButton onClick={(e) => onUpdateRosterTimes(e)}>Update Individual Event Entry Times for Entire Roster</PrimaryButton>
                    </div>
                  </div>
                </div>
              </div>}
            <div className="row">
              <div className="col-xs-12">
                <OrgUnitAdminRosterEntriesGrid
                  gridData={gridState.gridData}
                  isLoading={omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.isArrayLoading || omeMeetOrgUnitAthleteEntryState.isArrayLoading}
                  onEditAthleteClicked={onEditAthleteClicked}
                  onAddSecondaryRepToAthleteClicked={onAddSecondaryRepToAthleteClicked}
                  onDeleteAthleteClicked={onDeleteAthleteClicked}
                  showSecondaryRep={omeMeetOrgUnitEntryInfoState.objData?.allowSecondaryOrgUnitRepresentation ?? false}
                  onUpdateAthleteTimes={gridState.showUpdateButton === true && onUpdateAthleteTimes}
                  showStatusColumn={omeMeetOrgUnitEntryRosterPermissionsState?.objData?.orgUnitAthleteRegistrationAllowed === true &&
                    omeMeetOrgUnitEntryInfoState?.objData?.teamOrgUnitName !== 'Unattached' ? true : false}
                />
              </div>
            </div>
            {gridState.gridData?.length > 0 && gridState.showUpdateButton === true &&
              <div className="row">
                <div className={style.FloatRight}>
                  <div className="col-xs-12 usas-extra-top-margin">
                    <PrimaryButton onClick={(e) => onUpdateRosterTimes(e)}>Update Individual Event Entry Times for Entire Roster</PrimaryButton>
                  </div>
                </div>
              </div>}
            <PopUpModal
              widthPct={90}
              maxWidth={720}
              title={modalState.modalTitle}
              displayPopUp={modalState.displayPopUp}
              onModalCanceled={onModalCanceled}>
              <div className="row">
                <div className="col-xs-12">
                  <p><strong>Name:</strong> {modalState?.athleteName}</p>
                  <p><strong>Competition Category:</strong> {modalState?.competitionCategory}</p>
                  <p><strong>Birth Date:</strong> {modalState?.birthDate}</p>
                  <p><strong>Age at Meet:</strong> {modalState?.ageAtMeet}</p>
                  <p><strong>Status:</strong> {modalState?.status}</p>
                </div>
                <div className="col-xs-12 usas-extra-top-margin">
                  <SecondaryButton type="button" onClick={onModalCanceled}>Cancel</SecondaryButton>&nbsp;
                  <PrimaryButton type="button" onClick={(e) => onDeleteAthlete(e, modalState.orgUnitAthleteEntryId)}>Delete</PrimaryButton>
                </div>
              </div>
            </PopUpModal>
            <PopUpModal
              widthPct={90}
              maxWidth={720}
              title={secondaryRepModalState.modalTitle}
              displayPopUp={secondaryRepModalState.displayPopUp}
              onModalCanceled={onSecondaryRepModalCanceled}>
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-xs-12">
                    <p><strong>Athlete:</strong> {secondaryRepModalState?.athleteName} ({secondaryRepModalState?.competitionCategory}, {secondaryRepModalState?.ageAtMeet})</p>
                  </div>
                  <div className="col-xs-12 usas-extra-bottom-margin">
                    <Combobox
                      label={`Secondary Representation (${Constants.USAS_ORG_UNIT_LABEL_LSC})`}
                      name="secondaryOrgUnitName"
                      isLoading={approvedClubsForSecondaryRepState.isArrayLoading}
                      items={approvedClubsForSecondaryRepState.items || []}
                      valueToMatch={formState.secondaryOrgUnitName}
                      error={errorState.secondaryOrgUnitId}
                      message={errorState.secondaryOrgUnitId}
                      onChange={(newValue, newValueLabel, e) => { onValueTextPairChanged(newValue, 'secondaryOrgUnitId', newValueLabel, 'secondaryOrgUnitName', e); }}
                    />
                  </div>
                  {approvedClubsForSecondaryRepState.isArrayLoading === false &&
                    <div className="col-xs-12 usas-extra-top-margin">
                      <SecondaryButton type="button" onClick={onSecondaryRepModalCanceled}>Cancel</SecondaryButton>&nbsp;
                      <PrimaryButton type="submit">Save</PrimaryButton>
                    </div>}
                </div>
              </form>
            </PopUpModal>
            <PopUpModal
              widthPct={30}
              maxWidth={250}
              title={Constants.LOADING_MSG}
              displayPopUp={omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.isArrayLoading || omeMeetOrgUnitAthleteEntryState.isArrayLoading ||
                omeMeetOrgUnitEntryTimesState.isSaving || omeMeetOrgUnitEntryInfoState.isObjLoading} />
            <PopUpModal
              widthPct={30}
              maxWidth={250}
              title={Constants.SAVING_MSG}
              displayPopUp={omeMeetOrgUnitAthleteEntryState.isSaving || athleteSecondaryRepresentationState.isSaving} />
          </Fragment> :
          <Fragment>
            <form>
              <div className="row">
                <div className="col-xs-12">
                  <YesNoSwitch
                    label="Only Show Athletes Requiring Event Approval?"
                    name="onlyShowAthletesRequiringEventApproval"
                    checked={gridState.onlyShowAthletesRequiringEventApproval}
                    onChange={(value) => { setGridState({ ...gridState, onlyShowAthletesRequiringEventApproval: value }) }} />
                </div>
              </div>
            </form>
            <div className="row">
              <div className="col-xs-12">
                <OrgUnitAdminRosterEntriesGrid
                  gridData={gridState.gridData}
                  isLoading={omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.isArrayLoading}
                  showSecondaryRep={omeMeetOrgUnitEntryInfoState.objData?.allowSecondaryOrgUnitRepresentation ?? false}
                  showStatusColumn={omeMeetOrgUnitEntryRosterPermissionsState?.objData?.orgUnitAthleteRegistrationAllowed === true &&
                    omeMeetOrgUnitEntryInfoState?.objData?.teamOrgUnitName !== 'Unattached' ? true : false}
                />
              </div>
            </div>
            <PopUpModal
              widthPct={30}
              maxWidth={250}
              title={Constants.LOADING_MSG}
              displayPopUp={omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.isArrayLoading || omeMeetOrgUnitAthleteEntryState.isArrayLoading} />
          </Fragment>
        }
      </ViewTemplate>
    </Fragment>
  );
};

export default OrgUnitAdminRosterEntries;